module.exports = __webpack_public_path__ + "static/media/F1.8ef1989d.jpg";